module.exports = __webpack_public_path__ + "static/img/26_sirimlogo.c59a372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing_page_new/26_sirimlogo.png
// module id = nzQR
// module chunks = 62